import React, { useState, useEffect } from 'react';
import PaymentPage from './PaymentPage'; 
import { useNavigate } from 'react-router-dom';
import API from '../../pages/Api';
import { toast } from 'react-toastify';
import TableContainer from '../common/Tablecontainer'; 
import { useMediaQuery } from "react-responsive";

const UserDashboard = () => {
    const [selectedCourses, setSelectedCourses] = useState([]);
    const [showPayment, setShowPayment] = useState(false);
    const [activeCourses, setActiveCourses] = useState([]); 
    const [allCourses, setAllCourses] = useState([]);
    const [loadingCourses, setLoadingCourses] = useState(false);
    const [pendingCourses, setPendingCourses] = useState([]);
    const isMobile = useMediaQuery({
        maxWidth: 767,
    });
    

    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const userName = user?.name || '';

    const userInfo = {
        userid: user?.userid,
        email: user?.emailid,
        name: user?.name
    };
    const navigate = useNavigate();
    const handleCourseNavigation = (courseName) => {
        const course = courseName?.trim().toUpperCase();

        console.log("Clicked:", course);

        switch (course) {

            case "HAPPINESS INDEX TEST":
                navigate("/TGSH/user/HappinessIndexTest");
                break;

            case "MUDRABHYAS HINDI":
                navigate("/TGSH/user/MudrabhyasHindi");
                break;

            case "MUDRABHYAS ENGLISH":
                navigate("/TGSH/user/MudraAbhyasEnglish");
                break;

            case "MISSION 2022 CLUB":
                navigate("/TGSH/user/MissionClub");
                break;

            case "HA- DESIGN24 WOMEN":
                navigate("/TGSH/user/DESIGN24WOMEN");
                break;

            case "HA- DESIGN24 STUDENT":
                navigate("/TGSH/user/DESIGN24STUDENT");
                break;

            case "HA- DESIGN24 MEN":
                navigate("/TGSH/user/DESIGN24MEN");
                break;
            case "HAPPINESS MENTOR":
                navigate("/TGSH/user/HappinessMentor");
                break;

            default:
                alert(`Course page not available : ${courseName}`);
        }
    };

    const loadMasterCoursesForDashboard = async () => {
        setLoadingCourses(true);
        try {
            const res = await API.get(
            'getAllAmounts/'
            );

            console.log("API Response:", res.data);

            const courses = Array.isArray(res.data)
            ? res.data
            : Array.isArray(res.data.results)
                ? res.data.results
                : [];

            console.log("Courses Array:", courses);

            const formattedCourses = courses.map(course => ({
                id: course.amtId || course.amtid || course.id,
                name: course.AmtDesc || course.amtdesc || course.name || "N/A",
                d: course.Duration || course.duration || 30,
                f: course.Amount ?? course.amount ?? "0.00",
                amountDollar: course.AmountDollar ?? course.amountDollar ?? "0.00"
            }));

            setAllCourses(formattedCourses);
            setAllCourses(formattedCourses);
        } catch (err) {
            console.error("Failed to load all courses:", err);
        } finally {
            setLoadingCourses(false);
        }
    };

    const fetchActiveCourses = async () => {

        try {

            const token = localStorage.getItem('access_token');

            const res = await API.get(
                "user/active-courses/",
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );

            setActiveCourses(
                Array.isArray(res.data)
                    ? res.data
                    : []
            );

        } catch (err) {
            console.error(err);
        }
    };

    const fetchPendingCourses = async () => {

        try {

            const token = localStorage.getItem('access_token');

            const res = await API.get(
                "user/pending-courses/",
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );

            setPendingCourses(
                Array.isArray(res.data)
                    ? res.data
                    : []
            );

        } catch (err) {
            console.error(err);
        }
    };
    const checkActivatedCourses = async () => {
        try {
            const token = localStorage.getItem('access_token');
            const res = await API.get("user/newly-activated-courses/", {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            if (Array.isArray(res.data)) {
                res.data.forEach(course => {
                    toast.success(`${course} activated successfully`);
                });
            }
        } catch(err) { console.error(err); }
    };

    useEffect(() => {
        loadMasterCoursesForDashboard();
        fetchActiveCourses();
        fetchPendingCourses();
        checkActivatedCourses();
    }, []);
    useEffect(() => {
        console.log("showPayment =", showPayment);
    }, [showPayment]);

    const handleCheckboxChange = (course) => {

        const alreadyActivated = activeCourses.some(
            c => Number(c.courseid) === Number(course.id)
        );
        console.log("Course Selected:", course.id);
        console.log("Active Courses:", activeCourses);

        if (alreadyActivated) {

            toast.warning(
                "This course is already activated."
            );

            return;
        }

        const isPending = pendingCourses
            .map(Number)
            .includes(Number(course.id));
        console.log("Pending:", pendingCourses);
        console.log("Current:", course.id);

        if (isPending) {

            toast.warning(
                "Payment completed. Waiting for admin approval."
            );

            return;
        }

        setSelectedCourses(prev => {

            const exists = prev.some(
                item => item.id === course.id
            );

            if (exists) {
                return prev.filter(
                    item => item.id !== course.id
                );
            }

            return [...prev, course];
        });
        };
        
        if (showPayment) {
            return (
                <PaymentPage
                    selectedCourses={selectedCourses}
                    userInfo={userInfo}
                    onBack={() => setShowPayment(false)}
                />
            );
        }

    

    return (
        <div className="bg-gray-50 p-2 md:p-6">
            
                <div className="bg-white rounded-2xl shadow-sm border p-4 md:p-6 mb-5">
                    <p className="text-xs uppercase tracking-wider text-gray-500">
                        Welcome Back
                    </p>

                    <h1 className="text-xl md:text-3xl font-bold text-gray-800 mt-1">
                        Hello,
                        <span className="text-[#64a106]"> {userName}</span>
                    </h1>

                    <p className="text-sm text-gray-500 mt-2">
                        Manage your courses and track your learning journey.
                    </p>
                </div>
            

            {/* Active Courses */}
            <div className="bg-white">
                
                <div className="w-full py-3.5 text-center rounded-lg">
                    <h2 className="text-center text-xl md:text-4xl font-light text-gray-700 tracking-tight break-words">Active Courses</h2>
                    
                </div>

                {isMobile ? (
                    <div className="space-y-3">
                        {activeCourses.map((course, index) => (
                            <div
                                key={index}
                                className="
                                bg-white
                                rounded-2xl
                                border
                                shadow-sm
                                p-4
                                space-y-3
                                "
                            >
                                <div>
                                    <h3 className="font-bold text-[#032167] text-base">
                                        {course.course_name}
                                    </h3>

                                    <p className="text-xs text-gray-500">
                                        Active Course
                                    </p>
                                </div>

                                <div className="grid grid-cols-2 gap-3 text-sm">

                                    <div>
                                        <p className="text-gray-400 text-xs">
                                            Duration
                                        </p>
                                        <p className="font-semibold">
                                            {course.duration}
                                        </p>
                                    </div>

                                    <div>
                                        <p className="text-gray-400 text-xs">
                                            Remaining
                                        </p>
                                        <p className="font-semibold text-green-600">
                                            {course.remaining_days}
                                        </p>
                                    </div>

                                    <div>
                                        <p className="text-gray-400 text-xs">
                                            Activated
                                        </p>
                                        <p className="font-semibold">
                                            {course.activation_date}
                                        </p>
                                    </div>

                                    <div>
                                        <p className="text-gray-400 text-xs">
                                            Fee
                                        </p>
                                        <p className="font-bold text-[#032167]">
                                            ₹{course.fee}
                                        </p>
                                    </div>
                                </div>
                                <div className="pt-2">
                                    <button
                                        onClick={() => handleCourseNavigation(course.course_name)}
                                        className="
                                            bg-[#032167]
                                            text-white
                                            px-4
                                            py-2
                                            rounded-lg
                                            text-xs
                                            font-semibold
                                            hover:bg-blue-900
                                        "
                                    >
                                        Open Course
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                
                    <TableContainer
                        columns={['COURSE NAME', 'DURATION', 'ACTIVATION DATE', 'REMAINING DAYS', 'FEE (INR.)', 'FEE (USD)']}
                        data={activeCourses}
                        loading={false}
                        renderRow={(course, index, srNo, formatCurrency, formatDollar) => (
                            <tr key={index} className="border-b border-gray-200 hover:bg-gray-50 text-[13px] text-center">
                                <td className="p-3 border-r bg-gray-50/50 font-bold text-gray-400 text-center">{srNo}</td>
                                <td
                                    className="p-1 border-r text-left font-semibold uppercase text-[11px] md:text-[13px] break-words max-w-[120px] text-blue-700 cursor-pointer hover:underline"
                                    onClick={() => handleCourseNavigation(course.course_name)}
                                >
                                    {course.course_name}
                                </td>
                                <td className="p-3 border-r text-center">{course.duration}</td>
                                <td className="p-3 border-r text-center">{course.activation_date}</td>
                                <td className="p-3 border-r text-blue-700 font-bold text-center">{course.remaining_days}</td>
                                <td className="p-3 border-r text-right pr-6 font-bold text-gray-700">₹{formatCurrency(course.fee)}</td>
                                <td className="p-3 border-r text-right pr-6 font-bold text-green-700">${formatDollar(course.fee_usd || (course.fee / 84))}</td>
                                
                            </tr>
                        )}
                    />
                )}
                    
                
            </div>

            {/* All Courses */}
            <div className="bg-white">
                <div className="w-full py-3.5 text-center rounded-lg">
                    <h2 className="text-center text-xl md:text-4xl font-light text-gray-700 tracking-tight break-words">All Courses</h2>
                </div>

                {isMobile ? (
                    <div className="space-y-3">
                        {allCourses.map(course => (
                            <div
                                key={course.id}
                                className="bg-white rounded-2xl border shadow-sm p-4 flex justify-between items-start"
                            >
                                <div className="flex-1">
                                    <h3 className="font-bold text-[#032167] text-sm uppercase">
                                        {course.name}
                                    </h3>

                                    <p className="text-gray-500 text-xs mt-1">
                                        Duration : {course.d} Days
                                    </p>

                                    <p className="text-lg font-bold text-[#64a106] mt-2">
                                        ₹{course.f}
                                    </p>
                                </div>

                                <input
                                    type="checkbox"
                                    checked={selectedCourses.some(
                                        item => item.id === course.id
                                    )}
                                    onChange={() => handleCheckboxChange(course)}
                                    className="h-5 w-5 accent-[#64a106]"
                                />
                            </div>
                        ))}
                    </div>
                ) : (
                    <TableContainer
                        columns={[
                            'COURSE NAME',
                            'DURATION',
                            'FEE (INR.)',
                            'FEE (USD)',
                            'SELECT'
                        ]}
                        data={allCourses}
                        loading={loadingCourses}
                        renderRow={(course, index, srNo, formatCurrency, formatDollar) => (
                            <tr
                                key={course.id}
                                className="border-b border-gray-200 hover:bg-gray-50 text-[13px] text-center"
                            >
                                <td className="p-1 border-r bg-gray-50/50 font-bold text-gray-400 text-center">
                                    {srNo}
                                </td>
                                <td className="p-1 border-r text-left font-semibold uppercase">
                                    {course.name}
                                </td>
                                <td className="p-1 border-r text-center">
                                    {course.d} Days
                                </td>
                                <td className="p-1 border-r text-right pr-6 font-bold text-gray-700">
                                    ₹{formatCurrency(course.f)}
                                </td>
                                <td className="p-1 border-r text-right pr-6 font-bold text-green-700">
                                    ${formatDollar(course.amountDollar)}
                                </td>
                                <td className="p-1 border-r text-center">
                                    <input
                                        type="checkbox"
                                        disabled={
                                            activeCourses.some(
                                                c => Number(c.courseid) === Number(course.id)
                                            )
                                        }
                                        checked={
                                            selectedCourses.some(
                                                item => item.id === course.id
                                            )
                                        }
                                        onChange={() => handleCheckboxChange(course)}
                                        className="w-4 h-4 cursor-pointer accent-blue-600"
                                    />
                                </td>
                            </tr>
                        )}
                    />
                )}
            </div>
            
            <div
            className="
                fixed
                bottom-0
                left-0
                right-0
                p-3
                bg-white
                border-t
                shadow-2xl
                flex
                justify-center
                md:static
                md:bg-transparent
                md:border-none
                md:shadow-none
            "
            >
                <button
                    className="bg-[#032167]
                    text-white
                    w-full
                    md:w-auto
                    px-4
                    md:px-6
                    py-3
                    uppercase
                    font-bold
                    text-[12px]
                    md:text-[14px]
                    shadow-lg
                    hover:bg-blue-950
                    transition-all
                    rounded-md"
                    onClick={() => {
                        console.log("Button clicked");
                        console.log("Selected Courses:", selectedCourses);

                        if (selectedCourses.length > 0) {
                            setShowPayment(true);
                        } else {
                            toast.warn("Select Course");
                        }
                    }}
                >
                    Activate Selected
                </button>
            </div>
        </div>
    );
};

export default UserDashboard;